/* ==========================================================================
   Ryse - Theoric PDP: o kit mostra QUANTO se economiza, nao so QUANTOS POR CENTO

   Romulo, 12/07/2026: "aqueles 15% sao pra demonstrar o valor no kit."

   >>> ENTAO O 15% NAO E UM SELO DE DESCONTO. E UM ARGUMENTO. <<<
   E um argumento pela metade: porcentagem o cliente precisa CALCULAR; reais ele
   SENTE. "15% OFF" nao diz o que se ganha - diz uma razao entre dois numeros que
   ele teria que achar sozinho na tela.

   Os numeros reais deste kit:
     R$ 288,00 ... a soma dos itens avulsos (o compare-at)
     R$ 244,80 ... o kit (15% abaixo)
     R$  43,20 ... O QUE ELE GANHA POR LEVAR JUNTO   <- isto nao existia em lugar nenhum

   Este arquivo calcula essa linha e a escreve embaixo do preco. O selo "15% OFF"
   fica onde estava (Romulo pediu os dois): o selo chama, a linha explica.

   >>> DE ONDE VEM A CONTA <<<
   Do que ja esta na tela: o preco riscado e a porcentagem do proprio selo.
     economia = compare x pct
     288,00 x 15% = 43,20   (e 288 - 244,80 = 43,20 - fecha)
   Nao invento numero nem chumbo valor: se a Theoric mudar o desconto do kit no
   admin, esta linha muda sozinha. Se o tema um dia parar de mostrar o preco
   riscado, a linha simplesmente nao aparece - nada quebra.

   >>> POR QUE UM OBSERVER, E NAO SO UMA CHAMADA NO LOAD <<<
   O bloco de preco da Shopify e REDESENHADO a cada troca de variante (o tema pede
   o HTML novo pela Section Rendering API e substitui o elemento inteiro). A nossa
   linha seria varrida junto - e so para quem trocou de variante, que e justamente
   o caso que ninguem testa. O observer a reescreve toda vez que o bloco renasce.
   O guard "ja esta certa" e o que impede o loop: escrever a linha dispara o proprio
   observer, que chama a funcao de novo, que ve tudo no lugar e sai.

   Carregado por snippets/theoric-fav-button.liquid (que so existe na PDP).
   ========================================================================== */
(function () {
  var raiz = document.querySelector('.theoric-main-product');
  if (!raiz) return;

  /* "R$ 1.288,00" -> 1288.00
     O ponto e separador de MILHAR e a virgula e decimal - o inverso do que o
     parseFloat espera. Trocar a ordem aqui e o bug classico de e-commerce BR. */
  function paraNumero(texto) {
    if (!texto) return 0;
    var limpo = texto.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    var n = parseFloat(limpo);
    return isFinite(n) ? n : 0;
  }

  function paraReais(valor) {
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    });
  }

  function arrumar() {
    var bloco = raiz.querySelector('.theoric-pdp__price-block');
    if (!bloco) return;

    var selo = bloco.querySelector('.theoric-pdp__price-discount');
    var riscado = bloco.querySelector('.theoric-pdp__price-compare');

    /* produto avulso: nao ha kit, nao ha economia a mostrar */
    if (!selo || !riscado) return;

    var de = paraNumero(riscado.textContent);
    var pct = parseFloat((selo.textContent.match(/(\d+([.,]\d+)?)/) || [])[1] || '0');
    if (!de || !pct) return;

    var economia = de * (pct / 100);
    var texto = 'Economize ' + paraReais(economia) + ' levando o kit';

    var linha = bloco.querySelector('.theoric-pdp__kit-economia');

    /* ja esta escrita e correta - e este return que impede o observer de girar */
    if (linha && linha.textContent === texto) return;

    if (!linha) {
      linha = document.createElement('p');
      linha.className = 'theoric-pdp__kit-economia';
      bloco.appendChild(linha);   /* depois do parcelamento: fecha o argumento */
    }

    linha.textContent = texto;
  }

  arrumar();

  /* o bloco de preco renasce a cada troca de variante */
  var alvo = raiz.querySelector('.theoric-pdp__buyrow') || raiz;
  new MutationObserver(arrumar).observe(alvo, { childList: true, subtree: true });
})();
